import React from 'react';
import {ReactComponent as IconClose} from '../svgs/close.svg';
import {ReactComponent as IconUser} from '../svgs/user.svg';
import {ReactComponent as IconUserDelete} from '../svgs/user_delete.svg';
import {ReactComponent as IconLocalization} from '../svgs/localization.svg';
import {ReactComponent as IconSoftwareUpdate} from '../svgs/software_update.svg';
import localization from '../lib/localization/localization';
import { Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { Map, Marker, Overlay } from 'pigeon-maps'

export default function AddMenu({toNormalState, logOut, ui_version, username, UiMode, ui_mode, ui_language, updLanguage, users, addNewUser, deleteUser, is_new_software, clickUpdateButton, latt, long, lattLongUpd, pushWindow}){  

    let add_user_content = ''
    let delete_user_content = ''
    let select_login
    let update_software = ''

    if(is_new_software) {
        update_software = (
            <div className="add_menu_container">
                <div className="user_logo"><IconSoftwareUpdate /> </div>
                <div className="user_data">
                    <div className="user_name"> {localization.localize(ui_language).software_available} </div>
                </div>
                <div className="ui_mode">
                    <div> &nbsp; </div>
                    <div className="logout" onClick={() => clickUpdateButton()}> {localization.localize(ui_language).update} </div>
                </div>
            </div>
        )
    }

    let user_content = (
        <div className="add_menu_container">
            <div className="user_logo"><IconUser /> </div>
            <div className="user_data">
                <div className="user_name"> {localization.localize(ui_language).hello}, {username}</div>
                <div className="logout" onClick={() => logOut()}> {localization.localize(ui_language).logout} </div>
            </div>
            <div className="ui_mode">
                <IconLocalization className="icon_localization"/>
                <Select
                    onChange={(e)=> {updLanguage(e.target.value)}}
                    className="custom-select"
                    id="languages"
                    defaultValue={ui_language}>
                    {localization.languages.map( lang=>{
                        return <MenuItem value={lang}>{lang}</MenuItem>
                        })}
                </Select>
            </div>
        </div>
    )

    if (username === 'admin') {
        add_user_content = (
            <div className="add_menu_container">
                <div>{localization.localize(ui_language).add_new_user}</div>
                <div className="user_logo">
                    <div> {localization.localize(ui_language).login}: </div>
                    <input type="text" className="txt_add_user" id="newUserName"/>
                </div>
                <div className="user_data">
                    <div> {localization.localize(ui_language).password}: </div>
                    <input type="text" className="txt_add_user" id="newUserPass"/>
                </div>
                <div className="ui_mode">
                    <div className="logout" onClick={() => click_add_button()}> {localization.localize(ui_language).add} </div>
                </div>
            </div>
        )

        if (users.length != 0) {
            delete_user_content = (
                <div className="add_menu_container">
                    <div className="user_logo"><IconUserDelete /> </div>
                    <div className="user_data">
                        {localization.localize(ui_language).delete_user}
                        <p></p>
                        <Select
                            onChange={(e)=> {select_login = e.target.value}}
                            className="custom-select"
                            id="users"
                            defaultValue={users[0].login}>
                            {users.map( user=>{
                                return <MenuItem value={user.login}>{user.login}</MenuItem>
                                })}
                        </Select>
                    </div>
                    <div className="ui_mode">
                        <div> &nbsp; </div>
                        <div className="logout" onClick={() => click_delete_button()}> {localization.localize(ui_language).delete} </div>
                    </div>
                </div>
            )  
        }   
    }
    
    const MAPTILER_ACCESS_TOKEN = 'bniMwUz0H9Ti2NH4Q9yz'
    const MAP_ID = 'topographique'

    function mapTilerProvider (x, y, z, dpr) {
    return `https://api.maptiler.com/maps/${MAP_ID}/256/${z}/${x}/${y}${dpr >= 2 ? '@2x' : ''}.png?key=${MAPTILER_ACCESS_TOKEN}`
    }

    ////console.log('Latt_Long', latt, long-0.01)

    let map_content = (
        <div className="add_menu_container_map">
            <Map provider={mapTilerProvider} defaultCenter={[latt, long-0.01]} defaultZoom={10} minZoom={3} onClick={(e) => {
                
                let new_latt = e.latLng[0].toFixed(3);
                let new_long = e.latLng[1].toFixed(3);
                
                lattLongUpd(new_latt, new_long)
                }}>
            <Overlay anchor={[latt, long-0.001]} offset={[5, 5]}>
                <img src='/images/icons/home.png' className="map_icon" alt='Your home' />
            </Overlay>
                
            </Map>
        </div>
    )

    function click_add_button(){
        let new_username = document.getElementById('newUserName').value.replace(/\s/g, '');
        let password = document.getElementById('newUserPass').value;
        if ((new_username)&&(password)) {
            addNewUser(new_username, password)
        }
        else pushWindow('Enter new user Login and Password')
    }

    function click_delete_button(){
        if (select_login) deleteUser(select_login)
    }

    let theme_cont = (<div className="theme_container">
    <span className='theme0' onClick={() => UiMode(0)}></span>
    <span className='theme1' onClick={() => UiMode(1)}></span>
    <span className='theme2' onClick={() => UiMode(2)}></span>
    <span className='theme3' onClick={() => UiMode(3)}></span>
    </div>)
    /*
    <span className='theme4' onClick={() => UiMode(4)}></span>
    <span className='theme5' onClick={() => UiMode(5)}></span>
    <span className='theme6' onClick={() => UiMode(6)}></span>
    <span className='theme7' onClick={() => UiMode(7)}></span>
    */

    return(
        <div>
            <div className="addMenuEmpty" onClick={() => toNormalState()}></div>
            <div className="addMenu">
                <div className="close_elementPage" onClick={() => toNormalState()}><IconClose/></div>
                <div className="content-top"> {localization.localize(ui_language).additional} </div>
                <div className="addMenuContent">
                    {user_content}
                    {map_content}
                    {update_software}
                    {add_user_content}
                    {delete_user_content}
                </div>
                <div className="version">v.{ui_version}</div>
                    {theme_cont}
                    <div className="link"><a href='https://smartconnect.international/' target="_blank">{localization.localize(ui_language).about_project}</a></div>
            </div>
        </div>
    )

}